// Entry point for the build script in your package.json
import '@hotwired/turbo-rails';
import './controllers';
import 'trix';
import '@rails/actiontext';

// Add custom actions for TurboStream
import { StreamActions } from '@hotwired/turbo';

StreamActions.redirect = function () {
  const url = this.getAttribute('url');
  window.Turbo.visit(url);
};
///

import Rollbar from 'rollbar';

const rollbarClientAccessToken = document.body.dataset.rollbarClientToken;
if (rollbarClientAccessToken) {
  // eslint-disable-next-line no-unused-vars
  new Rollbar({
    accessToken: rollbarClientAccessToken,
    captureUncaught: true,
    payload: {
      environment: document.body.dataset.rollbarEnv || 'production',
    },
  });
}
